import React from "react";
import Slider from "../../../components/Slider";
import useWindowDimensions from "../../../helpers/Hooks/useWindowDimensions";
import UserTable from "./UserTable";

const NEReport = () => {
  const { height, width } = useWindowDimensions();
  const NameTable = {
    Name: "Peter Parker",
    SSN: "### ### 2314",
    DOB: "02-02-2002",
    FI: "Alabama Central Credit Union ",
    accNo: "### ### 1111",
    curAccBal: "$123.51",
  };

  const scoreFactors = [
    {
      content: "Balance history",
    },
    {
      content: "Recurring obligations vs. income",
    },
  ];

  return (
    <main>
      {/* Name table*/}
      <UserTable />
      {/* <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="py-2 inline-block min-w-full">
            <div className="overflow-hidden border border-border rounded p-0 m-0">
              <table className="min-w-full">
                <tbody className="text-left">
                  <tr className="border-b-[0.5px] border-border">
                    <th
                      scope="col"
                      className="px-4 py-[11px] text-xs font-semibold text-blackText "
                    >
                      Name :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {NameTable.Name}
                    </td>
                  </tr>
                  <tr className="border-b-[0.5px] border-border">
                    <th
                      scope="col"
                      className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
                    >
                      SSN :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {NameTable.SSN}
                    </td>
                  </tr>
                  <tr className="">
                    <th
                      scope="col"
                      className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
                    >
                      Report date :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {today}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> */}


      <main
        className={`px-1 overflow-y-scroll`}
        style={{ height: `${height - 303}px` }}
      >
        {/* Score Factors */}
        <section className="mt-[10px] py-0 px-2 flex items-center rounded-md">
          <div className="flex items-center justify-center">
            <section className="-mb-1 text-[50px] font-bold text-primary flex flex-col">
              <span>650</span>
              <span className="text-base text-blackText font-semibold ml-1">
                NinjaScore
              </span>
            </section>
            <section className="ml-4 text-greySecondary">
              <div className="w-full text-base font-medium">Score factors:</div>

              <div className="w-full flex flex-col ">
                {scoreFactors.map((factors, index) => {
                  return (
                    <div className="flex flex-row mb-[1px]" key={index}>
                      <div className="w-[7px] h-[6px] rounded-full mr-[10px] mt-1 bg-greySecondary"></div>
                      <div className="text-xs ">{factors.content}</div>
                    </div>
                  );
                })}
                {/* <div className="flex flex-row mb-[1px]">
                <div className="w-[7px] h-[6px] rounded-full mr-[10px] mt-1 bg-greySecondary"></div>
                <div className="text-xs ">
                  Excessive obligation in relation of Income
                </div>
              </div> */}

                {/* <div className="flex flex-row">
                <div className="w-[7px] h-[6px] rounded-full mr-[10px] mt-1 bg-greySecondary"></div>
                <div className="text-xs ">
                  Excessive obligation in relation of Income
                </div>
              </div> */}
              </div>
            </section>
          </div>
        </section>

        {/* Slider */}
        <Slider />

        {/* Financial table  */}
        <div className="flex flex-col mt-16">
          <div className="overflow-x-auto">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-hidden border border-border rounded-[4px]">
                <table className="min-w-full">
                  <tbody className="text-left">
                    <tr className="border-b-[0.5px] border-border">
                      <th
                        scope="col"
                        className="pl-4 py-[11px] w-[50%] text-xs font-semibold text-blackText"
                      >
                        Financial{width > 485 ? null : <br />} institution :
                      </th>
                      <td className="pr-4 whitespace-nowrap text-xs font-medium text-greySecondary ">
                        {NameTable.FI.split(" ").slice(0, 1)}{" "}
                        {NameTable.FI.split(" ").slice(1, 2)}{" "}
                        {width > 485 ? null : <br />}
                        {NameTable.FI.split(" ").slice(2, 3)}{" "}
                        {NameTable.FI.split(" ").slice(3, 4)}{" "}
                        {width > 485 ? null : <br />}
                        {NameTable.FI.split(" ").slice(4, 5)}
                      </td>
                    </tr>
                    <tr className="border-b-[0.5px] border-border ">
                      <th
                        scope="col"
                        className="pl-4 py-[11px] w-[50%] text-xs font-semibold text-blackText"
                      >
                        Account number :
                      </th>
                      <td className="pr-4 whitespace-nowrap text-xs font-medium text-greySecondary ">
                        {NameTable.accNo}
                      </td>
                    </tr>
                    <tr>
                      <th
                        scope="col"
                        className="pl-4 py-[11px] w-[50%] text-xs font-semibold text-blackText"
                      >
                        Current balance :
                      </th>
                      <td className="pr-4 whitespace-nowrap text-xs font-medium text-greySecondary ">
                        {NameTable.curAccBal}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Details table */}
        <div className="flex flex-col">
          <div className="overflow-x-auto">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-hidden">
                <table className="min-w-full">
                  {/* table head */}
                  <thead className="text-left">
                    <tr className=" flex justify-center text-center">
                      <div className="w-[50%] py-[11px]"></div>
                      <div className="w-[25%] py-[11px] text-xs font-semibold text-blackText border-x border-t border-border rounded-tl">
                        90 days
                      </div>
                      <div className="w-[25%] py-[11px] text-xs font-semibold text-blackText border-t border-r border-border rounded-tr">
                        365 days
                      </div>
                    </tr>
                  </thead>

                  <tbody className="text-left">
                    {/* 1st row */}
                    <tr className="flex justify-center">
                      <div className="w-[50%] px-[15px] flex items-center text-xs font-medium text-blackText border-l border-y border-border rounded-tl">
                        Number of
                        {width > 485 ? null : <br />} transactions
                      </div>
                      <div className="w-[25%] py-[11px] flex justify-center items-center text-xs font-medium text-greySecondary border border-border">
                        311
                      </div>
                      <div className="w-[25%] py-[11px] flex justify-center items-center text-xs font-medium text-greySecondary border-y border-r border-border">
                        1,269
                      </div>
                    </tr>
                    {/* 2nd row */}
                    <tr className="flex justify-center">
                      <div className="w-[50%] px-[15px] flex items-center text-xs font-medium text-blackText border-b border-l border-border">
                        Number of days
                        {width > 485 ? null : <br />} with transactions
                      </div>
                      <div className="w-[25%] py-[11px] flex justify-center items-center text-xs font-medium text-greySecondary border-b border-x border-border">
                        59
                      </div>
                      <div className="w-[25%] py-[11px] flex justify-center items-center text-xs font-medium text-greySecondary border-b border-r border-border">
                        239
                      </div>
                    </tr>
                    {/* 3rd row */}
                    <tr className="flex justify-center">
                      <div className="w-[50%] px-[15px] py-[11px] text-xs font-medium text-blackText border-b border-l border-border rounded-bl">
                        Average balance
                      </div>
                      <div className="w-[25%] py-[11px] flex justify-center items-center text-xs font-medium text-greySecondary border-b border-x border-border">
                        $109.92
                      </div>
                      <div className="w-[25%] py-[11px] flex justify-center items-center text-xs font-medium text-greySecondary border-b border-r border-border rounded-br">
                        $1,906.42
                      </div>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
    </main>
  );
};

export default NEReport;
